import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.from.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

import { OPEN_CONTACT, CLOSE_CONTACT, LOAD_CONTACT_FROM_SERVER, FAILED_TO_LOAD_CONTACTS, SAVE_CONTACT_SCROLLTOP } from "./Types";
import { ensureInArray } from "@/store/helpers";
import { STORE_SENT_MESSAGE, RECEIVE_NEW_MESSAGE, UPDATE_UNREAD_MESSAGE_COUNT, HISTORY_MESSAGES_LOADED, getUnreadMessageCountForDisplay } from "../messages/Types";
import { CLOSE_CHAT_BOX } from "../im/Types";
import { findDuplicates } from "@/pages/base/base";
import { assert } from "@/common/assert";
import RecalledChatMessageDto from "@/models/messages/RecalledChatMessageDto";
import { IS_DEV } from "@/common/fhtGlobalEnv";
var initialState = {
  currentContactChatId: undefined,
  contactChatIdsInList: [],
  contacts: {}
};
export function ContactReducer(state, action) {
  var _a, _b, e_1, _c, _d, _e, _f, _g, _h;

  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case CLOSE_CHAT_BOX:
      return __assign(__assign({}, state), {
        currentContactChatId: undefined
      });

    case OPEN_CONTACT:
      {
        var contact_1 = state.contacts[action.contact.chatId.encode()];
        assert(contact_1, "contact falsy??");
        var updatedContact_1 = contact_1.clone();
        updatedContact_1.unreadMessageCount = 0;
        return __assign(__assign({}, state), {
          currentContactChatId: action.contact.chatId.encode(),
          contactChatIdsInList: ensureInArray(action.contact.chatId.encode(), state.contactChatIdsInList),
          contacts: __assign(__assign({}, state.contacts), (_a = {}, _a[updatedContact_1.chatId.encode()] = updatedContact_1, _a))
        });
      }

    case CLOSE_CONTACT:
      var remainingContactChatIds = state.contactChatIdsInList.filter(function (chatId) {
        return chatId !== action.contact.chatId.encode();
      });

      if (!remainingContactChatIds.length) {
        return __assign(__assign({}, state), {
          contactChatIdsInList: remainingContactChatIds,
          currentContactChatId: undefined
        });
      }

      if (action.contact.chatId.encode() === state.currentContactChatId) {
        return __assign(__assign({}, state), {
          contactChatIdsInList: remainingContactChatIds,
          currentContactChatId: remainingContactChatIds[0]
        });
      }

      return __assign(__assign({}, state), {
        contactChatIdsInList: remainingContactChatIds
      });

    case LOAD_CONTACT_FROM_SERVER:
      return __assign(__assign({}, state), {
        contacts: __assign(__assign({}, state.contacts), (_b = {}, _b[action.contact.chatId.encode()] = action.contact, _b))
      });

    case FAILED_TO_LOAD_CONTACTS:
      {
        var copy = __assign({}, state.contacts);

        var failedToLoadChatIds = action.persistedContactInfos.map(function (ci) {
          return ci.chatId.encode();
        });

        try {
          for (var _j = __values(Object.keys(copy)), _k = _j.next(); !_k.done; _k = _j.next()) {
            var encodedChatId = _k.value;

            if (failedToLoadChatIds.includes(encodedChatId)) {
              delete copy[encodedChatId];
            }
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_k && !_k.done && (_c = _j["return"])) _c.call(_j);
          } finally {
            if (e_1) throw e_1.error;
          }
        }

        return __assign(__assign({}, state), {
          contacts: copy
        });
      }

    case STORE_SENT_MESSAGE:
      {
        var to = action.originalMessage.to;
        var contact_2 = state.contacts[to.chatId.encode()];
        var updatedContact_2 = contact_2.clone();
        updatedContact_2.lastUpdated = action.message.timestamp;
        updatedContact_2.messageIds = __spreadArray(__spreadArray([], __read(updatedContact_2.messageIds)), [action.message.id]);
        return __assign(__assign({}, state), {
          contacts: __assign(__assign({}, state.contacts), (_d = {}, _d[to.chatId.encode()] = updatedContact_2, _d))
        });
      }

    case UPDATE_UNREAD_MESSAGE_COUNT:
      {
        assert(action.chatId, "chatId is falsy!");
        var contact_3 = state.contacts[action.chatId.encode()];
        assert(contact_3, "contact falsy");
        var updatedContact_3 = contact_3.clone();
        var unreadCount = getUnreadMessageCountForDisplay(action);
        assert(typeof unreadCount === "number");
        updatedContact_3.unreadMessageCount = unreadCount;

        if (action.lastMessage) {
          updatedContact_3.lastUpdated = action.lastMessage.timestamp;
        }

        return __assign(__assign({}, state), {
          contacts: __assign(__assign({}, state.contacts), (_e = {}, _e[updatedContact_3.chatId.encode()] = updatedContact_3, _e))
        });
      }

    case RECEIVE_NEW_MESSAGE:
      {
        var contact_4 = state.contacts[action.chatId.encode()];
        assert(contact_4, "contact falsy");
        var updatedContact_4 = contact_4.clone();
        updatedContact_4.scrollTop = undefined;
        var isRecalledMessage = action.message instanceof RecalledChatMessageDto;
        assert(action.message, "action.message falsy");
        assert(action.message.id, "action.message.id falsy");

        if (!isRecalledMessage) {
          updatedContact_4.messageIds = __spreadArray(__spreadArray([], __read(updatedContact_4.messageIds)), [action.message.id]);
        }

        if (IS_DEV) {
          var dupes = findDuplicates(updatedContact_4.messageIds);

          if (dupes.size) {
            console.error("Duplicated messageIds: ", Array.from(dupes).join(", "));
          }

          assert(dupes.size === 0, "should not have dupes");
        }

        return __assign(__assign({}, state), {
          contacts: __assign(__assign({}, state.contacts), (_f = {}, _f[updatedContact_4.chatId.encode()] = updatedContact_4, _f))
        });
      }

    case HISTORY_MESSAGES_LOADED:
      {
        var contact_5 = state.contacts[action.contact.chatId.encode()];
        if (!contact_5) throw new Error("you got to make sure contact is loaded for this chatId before dispatching RECEIVE_NEW_MESSAGE");
        var updatedContact_5 = contact_5.clone();

        if (action.historyMessages.length === 0) {
          return state;
        }

        var historyMessageIds_1 = action.historyMessages.map(function (m) {
          return m.id;
        });

        var combined = __spreadArray(__spreadArray([], __read(historyMessageIds_1)), __read(updatedContact_5.messageIds.filter(function (mid) {
          return !historyMessageIds_1.includes(mid);
        })));

        updatedContact_5.messageIds = combined;
        updatedContact_5.messageHistoryInfo = {
          hasMoreMessages: action.historyMessages.length < 20,
          earliestHistoryTimestamp: action.historyMessages[0].timestamp,
          loadedMessageCount: updatedContact_5.messageHistoryInfo.loadedMessageCount + historyMessageIds_1.length
        };
        return __assign(__assign({}, state), {
          contacts: __assign(__assign({}, state.contacts), (_g = {}, _g[action.contact.chatId.encode()] = updatedContact_5, _g))
        });
      }

    case SAVE_CONTACT_SCROLLTOP:
      var contact = state.contacts[action.contact.chatId.encode()];
      var updatedContact = contact.clone();
      updatedContact.scrollTop = action.scrollTop;
      return __assign(__assign({}, state), {
        contacts: __assign(__assign({}, state.contacts), (_h = {}, _h[action.contact.chatId.encode()] = updatedContact, _h))
      });

    default:
      return state;
  }
}